import React, { useState, forwardRef } from "react";
import ReactModal from "react-modal";

import s from "./Modal.module.scss";
import { Button } from "../Button/Button";

export interface IAction {
	title: string;
	func: (event: React.MouseEvent<HTMLButtonElement>) => void;
	variant?: "primary" | "cancel";
	disabled?: boolean;
}

export interface IModalRef {
	open: () => void;
	close: () => void;
}

interface IProps {
	title?: string;
	actions?: IAction[];
	children?: JSX.Element;
	width?: number;
	testId?: string;
}

ReactModal.setAppElement("#root");

export const Modal = forwardRef<IModalRef, IProps>(({ title, actions, children, width, testId }, ref): JSX.Element => {
	const [isOpen, setOpen] = useState<boolean>(false);

	React.useImperativeHandle(ref, () => ({
		open() {
			setOpen(true);
		},
		close() {
			setOpen(false);
		},
	}));

	return (
		<ReactModal
			shouldCloseOnOverlayClick={true}
			onRequestClose={() => setOpen(false)}
			isOpen={isOpen}
			className={s.modal}
			overlayClassName={s.modal_overlay}
			testId={testId}
			style={{ content: { width: width ? `${width}px` : "200px" } }}>
			<div className={s.modalContent}>
				<div className={s.modalContent__column}>
					{title && (
						<div className={[s.modalContent__header, s.header].join(" ")}>
							<div className={s.header__row}>
								<div className={s.header__titleText}>{title}</div>
							</div>
						</div>
					)}
					{children && (
						<div className={s.body}>
							{children}
						</div>
					)}
					{actions?.length && (
						<div className={[s.modalContent__footer, s.footer].join(" ")}>
							<div className={s.footer__row}>
								{actions.map(action => (
									<Button key={action.title} disabled={action.disabled} className={s.footer__button} onClick={action.func} title={action.title} variant={action.variant}/>
								))}
							</div>
						</div>
					)}
				</div>
			</div>
		</ReactModal>
	);
});
